import axios from 'axios.js';
export default class VehicleApi {
  constructor() {
    this.api_token = null;
    this.client = null;
    this.user = JSON.parse(localStorage.getItem('user'));
  }

  init = () => {
    this.client = axios.create({
      timeout: 120000,
    });

    return this.client;
  };

  addVehicle = (data) => {
    return this.init().post('/api/vehicle/add', data);
  };



  getVehicleList = (params, depotId) => {
    return this.init().get('/api/vehicle/show/' + depotId, { params: params });
  };

  getVehicleListByOrgAndDepot = (params) => {
    return this.init().get('/api/vehicle/', { params: params });
  };




  deleteVehicle = (id) => {
    return this.init().post('/api/vehicle/delete_vehicle/' + id);
  };

  deleteVehicleByDepotId = (id) => {
    return this.init().delete('/api/vehicle/delete_vehicle_all/' + id);
  };

  updateVehicle = (data) => {
    return this.init().put('/api/vehicle/update', data);

  };

  getAllVehicleByOrg = (params) => {
    return this.init().get('/api/vehicle/org_vehicle', { params: params });
  }

  importVehicleByExcel = (formData) => {
    return this.init().post('/api/vehicle/import', formData
      , {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

  };
}
